import { createSlice } from '@reduxjs/toolkit';
import api from 'api';
import formErrorsHandle from '../../../utils/formErrorsHandle';
import toast from 'react-hot-toast';
import { GroupsActions } from '../dashboard/groupsReducer';

const initialState = {
  loading: false,
  formsList: [],
  privatePayFormsList: []
};
const dynamicForm = createSlice({
  name: 'dynamicForm',
  initialState,
  reducers: {
    setLoading(state, action) {
      return {
        ...state,
        loading: action.payload
      };
    },
    getList(state, action) {
      return {
        ...state,
        formsList: action.payload?.data,
        count: action.payload?.data?.count
      };
    },
    clearLists(state) {
      return {
        ...state,
        formsList: [],
        privatePayFormsList: []
      };
    },
    getPrivatePayList(state, action) {
      return {
        ...state,
        privatePayFormsList: action.payload?.data
      };
    },
    getTripFormById(state, action) {
      return {
        ...state,
        tripFormInfo: action.payload
      };
    },
    getById(state, action) {
      return {
        ...state,
        formInfo: action.payload
      };
    }
  }
});

export const dynamicFormActions = dynamicForm.actions;

export const createForm = (data, backNavigate) => async () => {
  try {
    const res = await api.post(`api/form`, data);
    if ((res.status === 200 || res.status === 201) && res?.data) {
      backNavigate();
      toast.success(`New form has been created.`);
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    formErrorsHandle(errors.response?.data, []);
  }
};
export const getDynamicForms = (data, url) => async (dispatch) => {
  dispatch(dynamicFormActions.setLoading(true));
  try {
    const res = await api.get(url ? url : `api/form`, { params: data });
    if (res.status === 200 && res?.data) {
      dispatch(dynamicFormActions.getList(res.data));
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    formErrorsHandle(errors.response?.data, []);
    return Promise.reject(errors.response?.data);
  } finally {
    dispatch(dynamicFormActions.setLoading(false));
  }
};
export const getDynamicFormsForTrips = (data, url) => async (dispatch) => {
  dispatch(dynamicFormActions.setLoading(true));
  try {
    const res = await api.get(url ? url : `api/form`, { params: data });
    if (res.status === 200 && res?.data) {
      dispatch(dynamicFormActions.getPrivatePayList(res.data));
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    formErrorsHandle(errors.response?.data, []);
    return Promise.reject(errors.response?.data);
  } finally {
    dispatch(dynamicFormActions.setLoading(false));
  }
};
export const editDynamicForm = (data, id, backNavigate) => async () => {
  try {
    const res = await api.put(`api/form/${id}`, data);
    if (res?.data) {
      backNavigate();
      toast.success(`Form has been changed.`);
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    formErrorsHandle(errors.response?.data, []);
    return Promise.reject(errors.response?.data);
  }
};

export const getFormById = (id, params) => async (dispatch) => {
  dispatch(dynamicFormActions.setLoading(true));
  try {
    const res = await api.get(`api/form/${id}`, { params });
    if (res.status === 200 && res?.data) {
      dispatch(dynamicFormActions.getById(res.data));
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    return Promise.reject(errors.response?.data);
  } finally {
    dispatch(dynamicFormActions.setLoading(false));
  }
};
export const getTripFormById = (id, params) => async (dispatch) => {
  dispatch(dynamicFormActions.setLoading(true));
  try {
    const res = await api.get(`api/form/${id}`, { params });
    if (res.status === 200 && res?.data) {
      dispatch(dynamicFormActions.getTripFormById(res.data));
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    return Promise.reject(errors.response?.data);
  } finally {
    dispatch(dynamicFormActions.setLoading(false));
  }
};
export const clearFormById = () => async (dispatch) => {
  dispatch(dynamicFormActions.getById(''));
  dispatch(dynamicFormActions.getTripFormById(''));
};
export const removeFormAction = (id) => async () => {
  try {
    const res = await api.delete(`api/form/${id}`);
    if (res.status === 200 && res?.data) {
      toast.success('Removed successfully!!!');
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    formErrorsHandle(errors.response?.data, []);
    return Promise.reject(errors.response?.data);
  }
};

export const getSingleForm = (data, params) => async (dispatch) => {
  dispatch(dynamicFormActions.setLoading(true));
  try {
    const res = await api.get(`api/form`, { params: data });
    if (
      res.status === 200 &&
      res?.data &&
      res?.data?.data &&
      res?.data?.data?.length
    ) {
      await dispatch(getFormById(res.data?.data[0].id, params));
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    formErrorsHandle(errors.response?.data, []);
    return Promise.reject(errors.response?.data);
  } finally {
    dispatch(dynamicFormActions.setLoading(false));
  }
};

export const cleaForms = () => async (dispatch) => {
  dispatch(dynamicFormActions.clearLists(''));
};
export default dynamicForm.reducer;
